import { render, staticRenderFns } from "./OverviewOpg.vue?vue&type=template&id=c705713e"
import script from "./OverviewOpg.vue?vue&type=script&lang=js"
export * from "./OverviewOpg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c705713e')) {
      api.createRecord('c705713e', component.options)
    } else {
      api.reload('c705713e', component.options)
    }
    module.hot.accept("./OverviewOpg.vue?vue&type=template&id=c705713e", function () {
      api.rerender('c705713e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/OverviewOpg.vue"
export default component.exports